import { addMinutes, format } from 'date-fns';
import pluralize from 'pluralize';
import prettyBytes from 'pretty-bytes';

const dateFormat = 'MMM d, yyyy';
const timeFormat = 'hh:mm aa';

export function filesSizeTags(size?: number | bigint | null, count?: number | null): string {
  const prettySize = getFormattedFileSize(size);
  return `${count} ${pluralize('file', count || 0)} | ${prettySize}`;
}

export function getFormattedFileSize(size?: number | bigint | null): string {
  const moreThanGig = Number(size || 0) > 1000000000;

  const prettySize = prettyBytes(Number(size || 0), { maximumFractionDigits: moreThanGig ? 2 : 0 });
  return `${prettySize}`;
}

export function formatPercent(percent: number, decimalPlaces = 1): string {
  if (percent === 0) return '0%';
  if (percent === 100) return '100%';

  return `${percent.toFixed(decimalPlaces).toString()}%`;
}

export const dateTimeFormat = `${dateFormat} ${timeFormat}`;

export function getDate(date?: string | Date, formatDate = dateFormat): string {
  if (!date) return 'N/A';
  return format(new Date(date), formatDate);
}

export function getDuration(startDate: string, duration: number): string {
  const date = new Date(startDate);
  const formattedStartTime = format(date, timeFormat);
  const endTime = addMinutes(date, duration);
  const formattedEndTime = format(endTime, timeFormat);

  return `${formattedStartTime} - ${formattedEndTime}`;
}
